import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionDayTripPlanLongStayParams } from "./long-stay-params";
import { QuestionDayTripPlanShortStayParams } from "./short-stay-params";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	stayLength: DayTripPlanCategoriesAndManagerStore["stayLength"];
};

export const QuestionDayTripPlanStayLength = ({ stayLength }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="滞在期間・連泊設定" categoryStore={stayLength}>
			<QuestionDayTripPlanLongStayParams />
			<QuestionDayTripPlanShortStayParams />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionDayTripPlanStayLength.displayName = "QuestionDayTripPlanStayLength";
